import { Grid } from 'antd-mobile'
import styles from '../index.scss'

interface DataType {
  name?: string
  code?: string
  phonePre?: string
}

interface IDpHotProps {
  data?: any[]
  onChange?: (record: DataType) => void
}

const HotTag = (props: IDpHotProps) => {
  return (
    <div className={styles['HOT']}>
      <Grid columns={2} gap={8}>
        {
          (props?.data || [])?.map((item: DataType) => {
            return (
              <Grid.Item key={'hot' + item?.code}>
                <div className={styles['HOT-tag']} onClick={() => props?.onChange?.(item)}>
                  <span className={styles['dp-location-select--item-city']}>
                    {item.name}
                  </span>
                  {
                    item?.phonePre && <span className={styles['dp-location-select--item-country']}>（{item.phonePre}）</span>
                  }
                </div>
              </Grid.Item>
            )
          })
        }
      </Grid>
    </div>
  )
}

export default HotTag
